import { useEffect, useMemo, useState } from "react";
import { PrintJson } from "../../theme/Component/PrintJson";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { _EmployeeContract, _single, _SocialSecurityType } from "../../../core/services/dataBean/EntityCatalog";
import { Alert } from "../../theme/Component/Alert";
import { SocialSecurityTypeConstants } from "../../bpm/config/Componentes/SocialSecurityTypeConstants";
import { BasicTable, MASK_NUMBER } from "../../theme/Component/BasicTable";
import { ListMenu } from "../../theme/Component/ListMenu";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { Modal } from "../../theme/Component/Modal";
import { SelectAccountantTree } from "../../contabilidad/catalogo-cuentas/AccountantTree/SelectAccountantTree";
import { SelectBudgetID } from "../../admin/configuracion/BudgetID/SelectBudgetID";
import { WelfareEntityTypeConstantsSelector } from "./ImportedPayrollBeneficiary/WelfareEntityTypeConstants";
import { TaxHoldeditor } from "./EmployeePayments/EmployeePayments.editor";
import { toast } from "react-toastify";
import { PayrollFactorVdosSelect } from "./PayrollFactorVdos/PayrollFactorVdosSelect";
import { AccountEditor } from "../../editor/AccountEditor";
import { BasicSwitch } from "../../theme/Component/BasicSwitch";


interface Props {
    employeeLiquidate: any;
}
export const SocialSecurityType = ({ employeeLiquidate }: Props) => {

    const { instance, setBean, bean, lista, setLista } = useDataBean(_SocialSecurityType);

    const [type, setType] = useState<number>(NaN);
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });

    useEffect(() => {
        if (type) {
            getLista();
        }
    }, [type, employeeLiquidate])

    const getLista = () => {
        instance.getSocialSecurityTypeCatalog(employeeLiquidate.IDPayrollType, type).then(
            (resp: any) => {
                setLista(resp);
            }
        ).catch(err => console.log(err))
    }

    const head = [
        { title: 'ID', property: 'IDSocialSecurityType', visible: true, mask: MASK_NUMBER },
        { title: 'Tipo', property: 'TypeName', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Factor de Configuración de Nómina', property: 'PayrollFactorName', visible: true },
        { title: '% Empleado', property: 'DeductionPercentValue', visible: true },
        { title: '% Empleador', property: 'EmployerPercentValue', visible: true },
        { title: 'Beneficiario', property: 'BeneficiaryName', visible: true },
        { title: 'Tipo de Entidad de Seguridad Social', property: 'WelfareEntityTypeName', visible: true },
        { title: 'Cuenta de Gasto', property: 'ExpensiveAccountantIDStrName', visible: true },
        { title: 'Cuenta Terceros', property: 'ThirdAccountantIDStrName', visible: true },
        { title: 'Cuenta por Pagar', property: 'PaymentAccountantIDStrName', visible: true },
        { title: 'Usar Beneficiario', property: 'UseBeneficiary', visible: true },
        { title: 'Reportar Porcentaje', property: 'ReportOtherPercent', visible: true },
        { title: 'Valor a Reportar', property: 'OtherPercentValue', visible: true },
        { title: 'Rubro Presupuestal', property: 'BudgetIDName', visible: true },
        { title: 'Factor de Retención', property: 'TaxHoldName', visible: true },
        { title: 'Clase Java', property: 'ClassForName', visible: true },
    ];

    const create = () => {
        setBean({
            IDEmployeeLiquidate: employeeLiquidate.IDEmployeeLiquidate,
            IDPayrollType: employeeLiquidate.IDPayrollType,
            Type: type,
        });
        setModal({ ...modal, "view": true, "name": "Agregar Tipo de Entidad de Seguridad Social" });
    }

    const updateItem = () => {
        instance.updateSocialSecurityType(bean).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => console.log(err))
    }

    const deleteItem = () => {
        instance.deleteSocialSecurityType(bean.IDSocialSecurityType).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        ).catch(err => console.log(err))
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "view": true, "name": "Editar Tipo de Entidad de Seguridad Social" }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true, "name": "Eliminar Tipo de Entidad de Seguridad Social" }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            updateItem();
        }
    }

    const validateForm = () => {
        const requiredFieldsCash = [
            "Type", "Name", "DeductionPercentValue", "EmployerPercentValue", "ExpensiveAccountantIDStr", "ThirdAccountantIDStr", "PaymentAccountantIDStr", "BudgetIDStr"
        ];


        let missing = [];

        for (let field of requiredFieldsCash) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }

        setMissingFields(missing);
        return missing.length
    };

    return (
        <div className="row">
            <div className="col-md-6">
                <SocialSecurityTypeConstants idSelector={type} onChange={(e) => { setType(parseInt(e)) }} />
            </div>
            <div className="col-md-12">
                <BasicTable iconButtons={iconButtonsItem} listButtons={listaBotones()} body={lista} head={head} rowSet={setBean}></BasicTable>
            </div>
            <div className="col-md-12">
                <Modal modal={modal} updateModal={setModal} eventModal={validateData}>
                    <div className="row">

                        <div className="col-md-6">
                            <label className={`${missingFields.includes('Type') ? 'has-error' : ''}`}>Tipo</label>
                            <SocialSecurityTypeConstants label=" " idSelector={bean.Type} onChange={(e) => { setBean({ ...bean, "Type": e }) }} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('Name') ? 'has-error' : ''}`}>Nombre</label>
                            <input type="text" className="form-control" value={bean.Name} onChange={(e) => { setBean({ ...bean, "Name": e.target.value }) }} />
                        </div>
                        <div className="col-md-6">
                            <label>Factor de Configuración de Nómina</label>
                            <PayrollFactorVdosSelect render={bean.NamePayroll} idSelector={bean.IDPayrollFactor} onChange={(e) => { setBean({ ...bean, "IDPayrollFactor": e.IDPayrollFactor, "NamePayroll": e.Name }) }} label=" " returnType="Object" />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('DeductionPercentValue') ? 'has-error' : ''}`}>% Empleado</label>
                            <input type="number" className="form-control" value={bean.DeductionPercentValue} onChange={(e) => { setBean({ ...bean, "DeductionPercentValue": parseFloat(e.target.value) }) }} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('EmployerPercentValue') ? 'has-error' : ''}`}>% Empleador</label>
                            <input type="number" className="form-control" value={bean.EmployerPercentValue} onChange={(e) => { setBean({ ...bean, "EmployerPercentValue": parseFloat(e.target.value) }) }} />
                        </div>
                        <div className="col-md-6">
                            <AccountEditor idAccount={bean.IDBeneficiary} label="Beneficiario" onChange={(e) => { setBean({ ...bean, IDBeneficiary: e?.IDAccount }) }} />
                        </div>
                        <div className="col-md-6">
                            <WelfareEntityTypeConstantsSelector idSelector={bean.WelfareEntityType} onChange={(e) => { setBean({ ...bean, "WelfareEntityType": e }) }} label="Tipo de Entidad de Seguridad Social" />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('ExpensiveAccountantIDStr') ? 'has-error' : ''}`}>Cuenta de Gasto</label>
                            <SelectAccountantTree label=" " jsonCode={bean.ExpensiveAccountantIDStr} onChange={(e) => { setBean({ ...bean, "ExpensiveAccountantIDStr": e.JsonCode }) }} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('ThirdAccountantIDStr') ? 'has-error' : ''}`}>Cuenta Terceros</label>
                            <SelectAccountantTree label=" " jsonCode={bean.ThirdAccountantIDStr} onChange={(e) => { setBean({ ...bean, "ThirdAccountantIDStr": e.JsonCode }) }} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('PaymentAccountantIDStr') ? 'has-error' : ''}`}>Cuenta por Pagar</label>
                            <SelectAccountantTree label=" " jsonCode={bean.PaymentAccountantIDStr} onChange={(e) => { setBean({ ...bean, "PaymentAccountantIDStr": e.JsonCode }) }} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('BudgetIDStr') ? 'has-error' : ''}`}>Rubro Presupuestal</label>
                            <SelectBudgetID label=" " tipoPresupuesto={null} edit={false} onChange={(e) => { setBean({ ...bean, "BudgetIDStr": e.JsonCode }) }} jsonCode={bean.BudgetIDStr} />
                        </div>
                        <div className="col-md-6">
                            <TaxHoldeditor label="Factor de Retención" idSelector={bean.IDTaxHold} onChange={(e) => { setBean({ ...bean, "IDTaxHold": e }) }} />
                        </div>
                        <div className="col-md-6">
                            <label>Valor a Reportar</label>
                            <input type="text" name="OtherPercentValue" className="form-control" value={bean.OtherPercentValue} onChange={(e: any) => { setBean({ ...bean, "OtherPercentValue": e.target.value }) }} />
                        </div>
                        <div className="col-md-6">
                            <BasicSwitch label="Usar Beneficiario" estado={bean.UseBeneficiary} eventChange={(e: any) => { setBean({ ...bean, "UseBeneficiary": e }) }} />
                        </div>
                        <div className="col-md-6">
                            <BasicSwitch label="Reportar Porcentaje" estado={bean.ReportOtherPercent} eventChange={(e: any) => { setBean({ ...bean, "ReportOtherPercent": e }) }} />
                        </div>
                        <div className="col-md-6">
                            <label>Clase Java</label>
                            <input type="text" className="form-control" value={bean.ClassForName} onChange={(e) => { setBean({ ...bean, "ClassForName": e.target.value }) }} />
                        </div>
                    </div>
                </Modal>
            </div>
            <div className="col-md-12">
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item</strong>
                </ModalConfirm>
            </div>
        </div>
    )
}